module.exports = __webpack_public_path__ + "img/builderall-logo-name.1962d3ab.svg";